module.exports = __webpack_public_path__ + "img/GGGCNGRC(disulfide bond ).c24aa6d0.png";